import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { firebaseConfig } from '../constants/firebase'

const app = initializeApp(firebaseConfig)

const messaging = getMessaging(app)

export { messaging, getToken, onMessage }
